module.exports = __webpack_public_path__ + "static/media/IIAC_logo.1ffb82bc.png";